"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagePropsMetaModules = exports.getMetaModulesPageProp = void 0;
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
const META_MODULES_PAGE_PROP = '_mmd';
exports.getMetaModulesPageProp = (0, libs_next_utils_1.createPagePropGetter)(META_MODULES_PAGE_PROP, {
    hideCookieConsent: false,
    hideBoosters: false,
});
function usePagePropsMetaModules(pageProps) {
    return (0, exports.getMetaModulesPageProp)(pageProps);
}
exports.usePagePropsMetaModules = usePagePropsMetaModules;
//# sourceMappingURL=MetaModules.utils.js.map